// 入口網「新版型」preview 入口（掛在隱藏 route /officialweb_preview）。
// 重用現有 ComponentLayout（header + navigation + footer[已含兩館]），內容為 home_page_v2。
// 選單＝與舊版 official_web/main_route.js 相同的「真實動態選單」（/dynamicWebsite/frontend/menu，major:1），
// 之後可由後台功能調整、此處即時反映；keys 指向 /officialweb/frontend/... 為真實可點連結。
import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import ComponentLayout from "../component_layout/afatsLayout";
import { BackgroundProvider } from "../component_layout/BackgroundContext";
import { useCRUDController } from "../controllers/CRUDController";
import HomePageV2 from "./views/home_page_v2";
import PreviewCatalog from "./views/catalog_preview";

const PreviewPortal = ({ prefixTitle = "空軍航空技術學院 資訊圖書中心" }) => {
  const [treeData, setTreeData] = useState([]);
  const { ResponseData, getData } = useCRUDController({
    apiRoute: "/dynamicWebsite/frontend/menu",
  });

  // 與 official_web/main_route.js 的 generateMenu 相同：treeData → 選單格式
  const generateMenu = (nodes, parentPath = "") => {
    let result = [];
    nodes.forEach((node) => {
      const currentPath = `${parentPath}/${node.permission_id}`.replace(/\/$/, "");
      if (node?.path_check === 0) {
        result.push({
          label: node?.name,
          key: `/officialweb/frontend${currentPath}`,
          path_check: node?.path_check,
          children: node?.children ? generateMenu(node.children, currentPath) : [],
        });
      } else {
        result.push({
          label: node?.name,
          key: node?.path,
          path_check: node?.path_check,
          children: node?.children ? generateMenu(node.children, currentPath) : [],
        });
      }
    });
    return result;
  };

  useEffect(() => {
    if (ResponseData?.find((_) => true)?.menu_permission_data) {
      setTreeData(ResponseData.find((_) => true).menu_permission_data);
    }
  }, [ResponseData]);

  useEffect(() => {
    getData({ major: 1 });
  }, []);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <BackgroundProvider>
            <ComponentLayout menuData={generateMenu(treeData)} />
          </BackgroundProvider>
        }
      >
        <Route index element={<HomePageV2 prefixTitle={prefixTitle} />} />
        {/* 館藏/電子資源查詢 preview（4-tab 依 tab 分流），原始 OPAC 頁不動 */}
        <Route path="search" element={<PreviewCatalog />} />
      </Route>
    </Routes>
  );
};

export default PreviewPortal;
